export default {"src":"/_next/static/image/public/images/flags/flag_248.ec44b452f9219d51e612e2416f284494.svg","height":16,"width":24};